<template>
  <div id="sending">

    <div class="hidden-sm-and-down">
      <PageHeader/>
    </div>
    <div class="hidden-md-and-up">
      <m-top/>
    </div>

    <div class="hidden-xs-only">
      <el-row type="flex" justify="center">
        <el-col :md="20" :lg="18" :xl="15">
          <div style="width: 100%; max-width: 1284px; margin: 0 auto;min-height:calc(100vh - 160px - 272px);">
            <div class="content">
              <div class="title">{{ t.title }}</div>
              <div class="detail">
                <div class="text normal">{{ t.intro1 }}</div>
                <div class="text normal">{{ t.intro2 }}</div>
                <div class="text normal">{{ t.telLabel }}<span class="tel">03-6260-6008</span></div>
                <div class="text small">{{ t.hoursPc }}</div>
                <div class="text small">{{ t.noteReception }}</div>
                <div class="text small">{{ t.noteClosed }}</div>
                <!-- <div class="text small">※　火曜、木曜臨時内装工事による、臨時休診にします。診療日再開予定しております</div> -->
                <!-- <div class="text small">※　月曜は、白川　太郎先生による「がんの自由診療」のみ実施しております</div> -->
                <div class="text small">{{ t.noteMonday }}</div>
                <!-- <div class="text small">※　10月21日（火）から11月30日（日）まで、院内改装のため、対面での診療を一時休止いたします。期間中は、オンライン遠隔診療のみご利用いただけます。</div> -->
                <div class="text small">{{ t.noteChinese }}</div>

                <div class="form">
                  <div class="title">
                    <span class="ja">{{ t.formTitle }}</span>
                    <span class="en" v-if="t.formTitleSub">{{ t.formTitleSub }}</span>
                  </div>
                  <div class="separator"></div>
                  <el-form label-position="left"
                          :model="formData"
                          :rules="rules"
                          :validate-on-rule-change="false"
                          ref="formData"
                          size="mini"
                          label-width="150px">
                    <el-form-item :label="t.labelName" prop="name">
                      <el-input size="mini" v-model="formData.name"></el-input>
                    </el-form-item>
                    <el-form-item :label="t.labelKana" prop="nameKana">
                      <el-input size="mini" v-model="formData.nameKana"></el-input>
                    </el-form-item>
                    <el-form-item :label="t.labelTel" prop="tel">
                      <el-input size="mini" v-model="formData.tel"></el-input>
                    </el-form-item>
                    <el-form-item :label="t.labelEmail" prop="email">
                      <el-input size="mini" v-model="formData.email"></el-input>
                    </el-form-item>
                    <el-form-item :label="t.labelPostcode" prop="postcode">
                      <el-input size="mini" v-model="formData.postcode"></el-input>
                    </el-form-item>
                    <el-form-item :label="t.labelAddress" prop="address">
                      <el-input size="mini" v-model="formData.address"></el-input>
                    </el-form-item>
                    <el-form-item :label="t.labelContent" prop="content">
                      <el-input type="textarea" :rows="4" size="mini" v-model="formData.content"></el-input>
                    </el-form-item>

                    <div class="agreement">
                      <el-checkbox v-model="checked"></el-checkbox>
                      <el-link id="agreementLink" :underline="false" @click="dialogVisible = true">{{ t.agreeLink }}</el-link>
                    </div>

                    <div class="submit">
                      <el-button @click="onSubmit('formData')" size="mini">{{ t.submit }}</el-button>
                    </div>
                  </el-form>

                </div>
              </div>

            </div>
          </div>

        </el-col>
      </el-row>

      <el-dialog :visible.sync="dialogVisible"
                 :show-close="false"
                 :title="t.policyTitle"
                 width="62.5%">
        <div class="dialog">
          <div class="text" v-for="(line, i) in t.policy" :key="'p' + i">{{ line }}</div>

          <div class="agree">
            <el-button @click="onAgree" size="mini">{{ t.agreeBtn }}</el-button>
          </div>
        </div>
      </el-dialog>

      <PageFooter/>
    </div>

    <div class="hidden-sm-and-up">

      <div class="m-title">{{ t.title }}</div>
      <div class="m-detail">
        <div>
          <div class="text normal">{{ t.intro1 }}</div>
          <div class="text normal">{{ t.intro2 }}</div>
        </div>

        <div>
          <div class="text normal">{{ t.telLabel }}</div>
          <div class="tel" onclick="window.location.href='tel:0362606008'">03-6260-6008</div>
          <div class="text small">
            <div>{{ t.hoursLabelM }}</div>
            <div>10:00 - 13:30 / 14:30-19:00</div>
          </div>
          <div class="text small">{{ t.noteReception }}</div>
          <div class="text small">{{ t.noteClosed }}</div>
          <!-- <div class="text small">※　火曜、木曜臨時内装工事による、臨時休診にします。診療日再開予定しております</div> -->
          <!-- <div class="text small">※　月曜は、白川　太郎先生による「がんの自由診療」のみ実施しております</div> -->
          <div class="text small">{{ t.noteMonday }}</div>
          <!-- <div class="text small">※　10月21日（火）から11月30日（日）まで、院内改装のため、対面での診療を一時休止いたします。期間中は、オンライン遠隔診療のみご利用いただけます。</div> -->
          <div class="text small">{{ t.noteChinese }}</div>
        </div>

        <div class="m-form">
          <div class="m-h2">
            <div class="ja">{{ t.formTitle }}</div>
            <div class="en" v-if="t.formTitleSub">{{ t.formTitleSub }}</div>
          </div>
          <div class="separator"></div>
          <el-form label-position="top"
                   :model="mFormData"
                   :rules="mRules"
                   :validate-on-rule-change="false"
                   ref="mFormData"
                   size="mini"
                   label-width="150px">

            <el-form-item :label="t.labelName" prop="name">
              <el-input size="mini" v-model="mFormData.name"></el-input>
            </el-form-item>
            <el-form-item :label="t.labelKana" prop="nameKana">
              <el-input size="mini" v-model="mFormData.nameKana"></el-input>
            </el-form-item>
            <el-form-item :label="t.labelTel" prop="tel">
              <el-input size="mini" v-model="mFormData.tel"></el-input>
            </el-form-item>
            <el-form-item :label="t.labelEmail" prop="email">
              <el-input size="mini" v-model="mFormData.email"></el-input>
            </el-form-item>
            <el-form-item :label="t.labelPostcode" prop="postcode">
              <el-input size="mini" v-model="mFormData.postcode"></el-input>
            </el-form-item>
            <el-form-item :label="t.labelAddress" prop="address">
              <el-input size="mini" v-model="mFormData.address"></el-input>
            </el-form-item>
            <el-form-item :label="t.labelContent" prop="content">
              <el-input type="textarea" :rows="4" size="mini" v-model="mFormData.content"></el-input>
            </el-form-item>

            <div class="m-agreement">
              <el-checkbox v-model="mChecked"></el-checkbox>
              <el-link id="m-agreementLink" :underline="false" @click="mDialogVisible = true">{{ t.agreeLink }}</el-link>
            </div>

            <div class="m-submit">
              <el-button @click="mOnSubmit('mFormData')" size="mini" round>{{ t.submit }}</el-button>
            </div>

          </el-form>
        </div>
      </div>

      <el-dialog :visible.sync="mDialogVisible"
                 :show-close="true"
                 center
                 :title="t.policyTitle"
                 width="90%">
        <div class="m-dialog">
          <div class="text" v-for="(line, i) in t.policy" :key="'mp' + i">{{ line }}</div>

          <div class="m-agree">
            <el-button @click="mOnAgree" size="mini" round>{{ t.agreeBtn }}</el-button>
          </div>
        </div>
      </el-dialog>

      <m-footer/>
    </div>

  </div>
</template>

<script>
import PageHeader from "@/components/PageHeader";
import PageFooter from "@/components/PageFooter";
import MTop from "../components/m/MTop";
import MFooter from "../components/m/MFooter";
import {Dialog, Notify} from "vant";

// 表示テキスト（ja はこれまでの表示と同一）。送信データの値は翻訳しない。
const T = {
  ja: {
    title: 'お問い合わせ',
    intro1: 'お問い合わせは、お電話・お問い合わせフォームより承っております。',
    intro2: 'お気軽にお問い合わせください。',
    telLabel: 'お電話でのお問い合わせ',
    hoursPc: '診療時間　月・火・木・金・土　10:00 - 13:30 / 14:30-19:00',
    hoursLabelM: '診療時間　月・火・木・金・土',
    noteReception: '※　受付は30分前までとなります',
    noteClosed: '※　休診日：水曜・日曜・祝日・年末年始',
    noteMonday: '※　月曜は、一般内科診療に加え、白川太郎医師による「がん自由診療」（11:00〜16:00）を実施しております',
    noteChinese: '※　中国語対応可能',
    formTitle: 'お問い合わせフォーム',
    formTitleSub: 'Contact Form',
    labelName: 'お名前',
    labelKana: 'ふりがな',
    labelTel: '電話番号',
    labelEmail: 'メールアドレス',
    labelPostcode: '郵便番号',
    labelAddress: '住所',
    labelContent: 'お問い合わせ内容',
    agreeLink: '個人情報の取り扱いについて、同意します。',
    submit: '送信する',
    policyTitle: '個人情報の取り扱いについて',
    policy: [
      '個人情報の利用目的',
      'ご入力いただいた個人情報は、お問い合わせ対応のみに利用します。',
      '個人情報の第三者提供について',
      'ご本人の同意がある場合または法令に基づく場合を除き、取得した個人情報を第三者に提供することはありません。',
      '個人情報の取り扱い委託について',
      '個人情報の取り扱いの一部を外部に委託する場合があります。個人情報を委託する場合は、個人情報保護水準を十分に満たしている者を選定し、適切な監督を行います。また、選定した委託先と個人情報保護に関する契約を取り交わします。',
      '開示対象個人情報の開示等',
      'ご本人からの求めにより、ご自身の個人情報の開示、訂正、削除、消去または利用の停止などに応じます。ご希望される場合には、下記の窓口までお問い合わせください。',
      'お問い合わせ窓口',
      '個人情報の取り扱いに関するお問い合わせは、下記の窓口までお願いいたします。',
      '患者さまサポート室　電話番号　03-6240-1393',
      '受付時間　10：00～18：00（土・日・祝日を除く）',
    ],
    agreeBtn: '同意します',
    ruleRequired: '※入力してください。',
    confirmSend: '送信しましたか？',
    yes: 'Yes',
    no: 'No',
    sent: '送信しました',
    cancelled: 'キャンセルしました',
    invalid: '入力してください。',
  },
  zh: {
    title: '咨询',
    intro1: '本院通过电话及咨询表单受理咨询。',
    intro2: '欢迎您随时咨询。',
    telLabel: '电话咨询',
    hoursPc: '诊疗时间　周一・周二・周四・周五・周六　10:00 - 13:30 / 14:30-19:00',
    hoursLabelM: '诊疗时间　周一・周二・周四・周五・周六',
    noteReception: '※　挂号截止时间为诊疗结束前30分钟',
    noteClosed: '※　休诊日：周三・周日・法定节假日・年末年初',
    noteMonday: '※　每周一除普通内科诊疗外，还由白川太郎医生提供“癌症自费诊疗”（11:00〜16:00）',
    noteChinese: '※　可提供中文服务',
    formTitle: '咨询表单',
    formTitleSub: 'Contact Form',
    labelName: '姓名',
    labelKana: '姓名读音（片假名或拼音均可）',
    labelTel: '电话号码',
    labelEmail: '电子邮箱',
    labelPostcode: '邮政编码',
    labelAddress: '地址',
    labelContent: '咨询内容',
    agreeLink: '我同意本院对个人信息的处理方式。',
    submit: '发送',
    policyTitle: '关于个人信息的处理',
    policy: [
      '个人信息的使用目的',
      '您填写的个人信息仅用于回复咨询。',
      '关于向第三方提供个人信息',
      '除经本人同意或依据法律法规的情形外，我们不会将所获取的个人信息提供给第三方。',
      '关于委托处理个人信息',
      '我们可能会将个人信息处理工作的一部分委托给外部机构。委托处理个人信息时，我们将选择充分满足个人信息保护标准的机构，并进行适当的监督。此外，我们还将与选定的受托方签订个人信息保护相关合同。',
      '可披露个人信息的披露等',
      '应本人要求，我们将受理本人个人信息的披露、更正、删除、消除或停止使用等请求。如有需要，请联系下述窗口。',
      '咨询窗口',
      '有关个人信息处理的咨询，请联系下述窗口。',
      '患者支持室　电话号码　03-6240-1393',
      '受理时间　10:00～18:00（周六、周日及法定节假日除外）',
    ],
    agreeBtn: '同意',
    ruleRequired: '※请填写此项。',
    confirmSend: '确定要发送吗？',
    yes: '是',
    no: '否',
    sent: '已发送',
    cancelled: '已取消',
    invalid: '请填写必填项。',
  },
  en: {
    title: 'Contact Us',
    intro1: 'We accept inquiries by phone or through the contact form.',
    intro2: 'Please feel free to contact us.',
    telLabel: 'Inquiries by phone',
    hoursPc: 'Consultation hours: Mon, Tue, Thu, Fri, Sat, 10:00 - 13:30 / 14:30-19:00',
    hoursLabelM: 'Consultation hours: Mon, Tue, Thu, Fri, Sat',
    noteReception: '* Reception closes 30 minutes before the end of consultation hours',
    noteClosed: '* Closed: Wednesdays, Sundays, public holidays and the New Year holidays',
    noteMonday: '* On Mondays, in addition to General Internal Medicine, Dr. Taro Shirakawa offers Cancer Care (Self-pay) (11:00–16:00)',
    noteChinese: '* Chinese-language support available',
    formTitle: 'Contact Form',
    formTitleSub: '',
    labelName: 'Name',
    labelKana: 'Name reading (katakana or alphabet)',
    labelTel: 'Phone number',
    labelEmail: 'Email address',
    labelPostcode: 'Postal code',
    labelAddress: 'Address',
    labelContent: 'Inquiry details',
    agreeLink: 'I agree to the handling of my personal information.',
    submit: 'Send',
    policyTitle: 'Handling of Personal Information',
    policy: [
      'Purpose of use of personal information',
      'The personal information you enter will be used only to respond to your inquiry.',
      'Provision of personal information to third parties',
      'Except with your consent or where required by law, we will not provide the personal information we obtain to any third party.',
      'Outsourcing the handling of personal information',
      'We may outsource part of the handling of personal information to outside parties. In that case, we will select parties that fully meet personal information protection standards and supervise them appropriately. We will also conclude a personal information protection agreement with each selected contractor.',
      'Disclosure, etc. of personal information subject to disclosure',
      'At your request, we will respond to requests for disclosure, correction, deletion, erasure or suspension of use of your own personal information. If you wish to make such a request, please contact the office below.',
      'Contact office',
      'For inquiries regarding the handling of personal information, please contact the office below.',
      'Patient Support Office, Tel: 03-6240-1393',
      'Hours: 10:00–18:00 (excluding Saturdays, Sundays and public holidays)',
    ],
    agreeBtn: 'I agree',
    ruleRequired: '* This field is required.',
    confirmSend: 'Send your inquiry?',
    yes: 'Yes',
    no: 'No',
    sent: 'Your inquiry has been sent.',
    cancelled: 'Cancelled.',
    invalid: 'Please fill in the required fields.',
  },
}

// 必須チェック（表示メッセージのみ言語に合わせる）
function requiredRules(message) {
  const r = () => [{required: true, message, trigger: 'change'}]
  return {name: r(), nameKana: r(), email: r(), content: r()}
}

export default {
  name: "Sending",
  components: {MFooter, MTop, PageFooter, PageHeader},
  computed: {
    t() {
      return T[this.$lang] || T.ja
    },
    rules() {
      return requiredRules(this.t.ruleRequired)
    },
    mRules() {
      return requiredRules(this.t.ruleRequired)
    },
  },
  data() {
    return {
      formData: {
        name: '',
        nameKana: '',
        tel: '',
        email: '',
        postcode: '',
        address: '',
        content: ''
      },
      mFormData: {
        name: '',
        nameKana: '',
        tel: '',
        email: '',
        postcode: '',
        address: '',
        content: ''
      },
      checked: false,
      mChecked: false,
      dialogVisible: false,
      mDialogVisible: false
    }
  },
  methods: {
    onSubmit(formData) {
      /*送信时，需要检查checked的值。。*/
      if (!this.checked) {
        let a = document.getElementById('agreementLink')
        a.style.color = 'red'
        return
      }

      this.$refs[formData].validate((valid) => {
        if (valid) {
          this.$confirm(this.t.confirmSend, {
            confirmButtonText: this.t.yes,
            cancelButtonText: this.t.no
          }).then(() => {
            
            // console.log(`name:${formData.name}`)
            // console.log(`nameKana:${formData.nameKana}`)
            // console.log(`tel:${formData.tel}`)
            // console.log(`email:${formData.email}`)
            // console.log(`postcode:${formData.postcode}`)
            // console.log(`address:${formData.address}`)
            // console.log(`content:${formData.content}`)


            axios.post(`${this.GLOBAL.host}/t/contact/insert`, this.formData).then(() => {
              this.$message({
                type: 'success',
                message: this.t.sent
              })
            })
          }).catch(() => {
            this.$message({
              type: "info",
              message: this.t.cancelled
            })
          })
        } else {
          this.$message({
            type: 'error',
            message: this.t.invalid
          })
        }
      })

    },
    mOnSubmit(mFormData) {
      /*送信时，需要检查checked的值。。*/
      if (!this.mChecked) {
        let a = document.getElementById('m-agreementLink')
        a.style.color = 'red'
        return
      }

      this.$refs[mFormData].validate((valid) => {
        if (valid) {
          Dialog.confirm({
            message: this.t.confirmSend,
            confirmButtonText: this.t.yes,
            cancelButtonText: this.t.no
          }).then(() => {
            // スマホ版のフォームの入力内容を送る（以前は PC 版の formData を送っていた）
            axios.post(`${this.GLOBAL.host}/t/contact/insert`, this.mFormData).then(() => {
              Notify({
                message: this.t.sent,
                type: 'success'
              })
            })
          }).catch(() => {
            Notify({
              message: this.t.cancelled,
              type: 'warning'
            })
          })
        } else {
          Notify({
            message: this.t.invalid,
            type: 'danger'
          })
        }
      })
    },
    onAgree() {
      this.dialogVisible = false
      this.checked = true
    },
    mOnAgree() {
      this.mDialogVisible = false
      this.mChecked = true
    }
  },
  watch: {
    checked() {
      if (this.checked) {
        let a = document.getElementById('agreementLink')
        a.style.color = '#333'
      }
    },
    mChecked() {
      if (this.mChecked) {
        let a = document.getElementById('m-agreementLink')
        a.style.color = '#333'
      }
    }
  }
}
</script>

<style scoped>
/* PC */
.content {
  padding: 30px;
}
.title {
  color: #535353;
  font-size: 24px;
}
.detail {
  margin-top: 30px;
}
.detail .text{
  margin-top: 10px;
}
.detail .text:nth-child(3) {
  margin-top: 40px;
}
.detail .text .tel {
  margin-left: 20px;
  font-size: 22px;
  color: #62b6e2;
}
.detail .small {
  font-size: 14px;
}

.form {
  margin-top: 50px;
}
.form .title {
  font-size:20px;
}
.title .en {
  margin-left: 20px;
  font-size: 16px;
  color: #aaa;
  letter-spacing: 3px;
}
.separator {
  margin: 20px 0;
  border-top: 1px dotted #CCCCCC;
}
.form /deep/ .el-form .el-form-item div {
  width: 400px;
}
.agreement {
  margin: 20px 0 0 150px;
}
.agreement a {
  margin-left: 10px;
}

/*送信按钮*/
.submit {
  margin: 40px 0 0 150px;
}
.submit /deep/ .el-button {
  border-radius: 5px;
  background-color: #62b6e2;
  color: #fff;
  font-size: 14px;
  padding: 10px 40px;
}

/*弹窗配置*/
::v-deep .el-dialog {
/* /deep/ .el-dialog { */
  padding: 30px 30px 10px 30px;
  border-radius: 10px;
}
/* /deep/ .el-dialog .el-dialog__body { */
::v-deep .el-dialog .el-dialog__body {
  padding-top: 10px;
  padding-bottom: 10px;
}
.dialog .text {
  line-height: 20px;
  font-size: 14px;
}
.dialog .text:nth-child(3), .dialog .text:nth-child(5), .dialog .text:nth-child(7), .dialog .text:nth-child(9) {
  margin-top: 20px;
}

.dialog .agree {
  text-align: right;
  margin: 30px auto;
}
.dialog .agree /deep/ .el-button {
  width: 130px;
  height: 30px;

  background-color: #62b6e2;
  color: #FFFFFF;
  border-radius: 5px;
}

/* SP */
.m-title {
  color: #535353;
  font-size: 20px;
  text-align: center;
  padding: 30px 20px 20px;
}
.m-detail {
  font-size: 14px;
  padding: 0 20px;
}
.m-info {
  margin-top: 20px;
}
.m-info .tel {
  color: #62b6e2;
  font-size: 20px;
  font-weight: bold;
  margin: 10px 0;
}
.m-info .small {
  font-size: 12px;
}
.m-form .m-h2 {
  font-size: 20px;
  margin-top: 20px;
}
.m-form .m-h2 .en {
  margin-top: 6px;
  font-size: 16px;
  color: #9e9e9e;
  letter-spacing: 3px;
}
.m-form /deep/ .el-form>div {
  margin-bottom: 10px;
}
.m-form /deep/ .el-form>div>label {
  padding-bottom: 2px;
}
.m-form /deep/ .el-form .m-agreement > a {
  margin-left: 10px;
}
.m-form /deep/ .el-form .m-submit,
.m-form /deep/ .el-form .m-agreement {
  text-align: center;
}
.m-form .m-submit /deep/ .el-button {
  background-color: #62b6e2;
  border-radius: 5px;
  border: none;
  box-shadow: 0 1px 2px #ccc;
  color: #fff;
  font-size: 14px;
  padding: 10px 40px;
  margin: 20px 0;
}
.hidden-md-and-up /deep/ .el-dialog {
  padding: 30px 0 10px 0;
  border-radius: 10px;
}
.hidden-md-and-up /deep/ .m-dialog .text {
  line-height: 20px;
  font-size: 14px;
}
.hidden-md-and-up /deep/ .m-dialog .text:nth-child(3),
.hidden-md-and-up /deep/ .m-dialog .text:nth-child(5),
.hidden-md-and-up /deep/ .m-dialog .text:nth-child(7),
.hidden-md-and-up /deep/ .m-dialog .text:nth-child(9) {
  margin-top: 20px;
}

.hidden-md-and-up /deep/ .m-dialog .m-agree {
  text-align: center;
  margin: 2rem 0 1rem;
}
.hidden-md-and-up /deep/ .m-dialog .m-agree .el-button {
  font-size: 18px;
  background-color: #62b6e2;
  color: #fff;
}
</style>
